import React from 'react'
import { TableProps } from 'antd/lib/table'

import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { Text } from 'src/components/Ant'

import R6HeaderTable, { R6HeaderTableGeneric } from './r6-header-table-generic'

const columns: ColumnProps<R6HeaderTableGeneric>[] = [
  {
    align: 'center',
    dataIndex: 'name',
    key: 'name',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.6.header.agencies.agency'
  },
  {
    align: 'center',
    dataIndex: 'total',
    key: 'total',
    render: (value: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.6.header.agencies.total'
  },
  {
    align: 'center',
    dataIndex: 'percent',
    key: 'percent',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.6.header.agencies.percent'
  }
]

function R6HeaderTableAgencies({
  dataSource
}: TableProps<R6HeaderTableGeneric>) {
  return <R6HeaderTable columns={columns} dataSource={dataSource} />
}

export default R6HeaderTableAgencies
